/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
// @ts-nocheck
import React, { useState, useEffect } from 'react'
import { useAccount } from 'wagmi'
import { readContract } from '@wagmi/core'
import TopBar from '../components/TopBar.jsx'
import CustomRadioButton from '../components/CustomRadioButton.jsx'
import ClipLoader from 'react-spinners/ClipLoader'
import { StringParam, useQueryParam } from 'use-query-params'
import TradeCard from '../components/TradeCard.jsx'
import BalanceCard from '../components/BalanceCard.jsx'
import LaunchpadCard from '../components/LaunchpadCard.jsx'
import { imageUrl, apiUrl, fetchBnbPrice, supportedChainIds, chainLogos, scanLinks, coinNames, projectName } from '../utils/constants.ts'
import { getMulticallAddress } from '../utils/addressHelpers.ts'
import rot13 from '../utils/encode.ts'
import { BASE_URL } from '../utils/constants.ts'
import { config } from '../config'
import MultiCallAbi from '../config/MultiCallAbi.json'
import toast from 'react-hot-toast'
import Footer from '../components/Footer';

const Profile = () => {
  let [profileAddress] = useQueryParam('address', StringParam)
  const { address } = useAccount()
  if (profileAddress === "undefined")
    profileAddress = address;
  let [loading, setLoading] = useState(false)
  const [fetched, setFetched] = useState(false)
  const [fetched1, setFetched1] = useState(false)
  const [selectedOption, setSelectedOption] = useState('Balances')
  const handleSelect = value => setSelectedOption(value)
  const [funLists, setFunListData] = useState([])
  const [funBalances, setFunBalances] = useState([])
  const [history, setHistory] = useState([{ amount: 0, name: '', token: '', type: '', date: '' }])

  useEffect(() => {
    const FetchBalances = async () => {
      try {
        setLoading(true)
        for (const chainId of supportedChainIds) {
          let mainInfo = await readContract(config, {
            address: getMulticallAddress(chainId),
            abi: MultiCallAbi,
            functionName: 'getUserBalance',
            args: [profileAddress],
            chainId: chainId
          })

          if (mainInfo) {
            if (mainInfo[0].length > 0) {
              for (let i = mainInfo[0].length - 1; i >= 0; i--) {
                const name = mainInfo[0][i]
                const symbol = mainInfo[1][i]
                const contractAddress = mainInfo[2][i]
                const balance = Number(mainInfo[3][i]) / (10 ** 18)
                let logoUrl = imageUrl + 'logo/' + projectName + "-" + chainId + "-" + contractAddress + '.png'
                const funData = {
                  chainId,
                  name: name,
                  symbol: symbol,
                  contractAddress: contractAddress,
                  logoUrl: logoUrl,
                  balance: balance
                }
                setFunBalances(prev => [...prev, funData])
              }
            }
          }
        }
        setLoading(false)
        setFetched1(true)
      } catch (e) {
        setLoading(false)
        console.error(e)
      }
    }

    const FetchTrades = async () => {
      try {
        await fetch(
          apiUrl + `/getUserHistory/${profileAddress}`,
          {
            method: 'GET'
          }
        ).then(async res => {
          let data = await res.json()
          if (data.length > 0) {
            let history = {}
            let historyData: any[] = []
            for (let i = 0; i < data?.length; i++) {
              let chainId = data[i].chainId
              let amount = data[i].amount
              let buyer = data[i].buyer
              let name = data[i].name
              let token = data[i].token
              let type = data[i].type
              let contract = data[i].contract
              let currentDate = Date.now()
              let timestamp = currentDate / 1000 - Number(data[i].timestamp)
              let date
              if (timestamp > 86400) {
                date = (timestamp / 86400).toFixed(0) + ' days ago'
              } else if (timestamp > 3600) {
                date = (timestamp / 3600).toFixed(0) + ' hours ago'
              } else if (timestamp > 0) {
                date = (timestamp / 60).toFixed(0) + ' mins ago'
              } else {
                date = ' just now'
              }
              history = { chainId, amount: amount, buyer: buyer, name: name, token: token, type: type, contract: contract, date: date }
              historyData.push(history)
            }
            setHistory(historyData)
          } else {
            setHistory([{ amount: 0, name: '', token: '', type: '', date: '' }])
          }
        })
      } catch (e) {
        console.error(e)
      }
    }

    const FetchDeployedData = async () => {
      try {
        setLoading(true)

        for (const chainId of supportedChainIds) {
          const ethPrice = await fetchBnbPrice();

          let mainInfo = await readContract(config, {
            address: getMulticallAddress(chainId),
            abi: MultiCallAbi,
            functionName: 'getUserDeployMainInfo',
            args: [profileAddress],
            chainId: chainId
          })
          let otherInfo = await readContract(config, {
            address: getMulticallAddress(chainId),
            abi: MultiCallAbi,
            functionName: 'getUserDeployOtherInfo',
            args: [profileAddress],
            chainId: chainId
          })
          const restInfo = await readContract(config, {
            address: getMulticallAddress(chainId),
            abi: MultiCallAbi,
            functionName: 'getRestInfo',
            chainId: chainId
          })

          let tokenInfo = await readContract(config, {
            address: getMulticallAddress(chainId),
            abi: MultiCallAbi,
            functionName: 'getUserBalance',
            args: [profileAddress],
            chainId: chainId
          })

          if (mainInfo && otherInfo) {
            if (mainInfo[0].length > 0) {
              for (let i = mainInfo[0].length - 1; i >= 0; i--) {
                const contractAddress = mainInfo[4][i]
                const tokenAddress = tokenInfo[2][i]
                const virtualLpAmounts = Number(mainInfo[1][i]) * ethPrice
                const tokenPrice = Number(mainInfo[2][i])
                const marketCap = (tokenPrice * 1000000000 * Number(ethPrice)) / 10 ** 12
                const website = otherInfo[2][i]
                const twitter = otherInfo[3][i]
                const telegram = otherInfo[4][i]
                const progress = marketCap * 100 / 50000
                const liquidity = virtualLpAmounts
                const name = otherInfo[0][i]
                let logoUrl = imageUrl + 'logo/' + projectName + "-" + chainId + "-" + contractAddress + '.png'
                let bannerUrl = imageUrl + 'banner/' + projectName + "-" + chainId + "-" + contractAddress + '.png'
                let blockchainLogoUrl = chainLogos[chainId]
                let devAddress = mainInfo[5][i]
                let dexAddress = 'https://pancakeswap.finance/swap'
                let dexName = 'PancakeSwap'
                const description = restInfo[2][i]
                const funData = {
                  chainId: chainId,
                  progress: progress,
                  Liquidity: liquidity,
                  tokenName: name,
                  tokenDescription: description,
                  logoUrl: logoUrl,
                  bannerUrl: bannerUrl,
                  address: mainInfo[4][i],
                  depositedAmount: Number(mainInfo[3][i]) * ethPrice / 10 ** 18,
                  contractAddress: contractAddress,
                  tokenAddress: tokenAddress,
                  dexAddress: dexAddress,
                  devAddress: devAddress,
                  dexName: dexName,
                  marketCap: marketCap,
                  website: website,
                  twitter: twitter,
                  telegram: telegram,
                  blockchainLogoUrl: blockchainLogoUrl,
                  funAddress: contractAddress
                }
                setFunListData(prevState => [...prevState, funData])
              }
            }
          }
        }
        setLoading(false)
        setFetched(true)
      } catch (e) {
        setLoading(false)
        console.error(e)
      }
    }

    if (profileAddress) {
      if (selectedOption === 'Deploys' && !fetched) {
        FetchDeployedData()
      } else if (selectedOption === 'Balances' && !fetched1) {
        FetchBalances()
      } else if (selectedOption === 'Trades') {
        FetchTrades()
      }
    }
  }, [selectedOption, profileAddress])


  const referlink = address ? `${BASE_URL}/?ref=${rot13(address)}` : `${BASE_URL}/?ref=`

  const copyAddress = address => async e => {
    e.stopPropagation()
    e.preventDefault()
    if (document.queryCommandSupported('copy')) {
      const ele = document.createElement('textarea')
      ele.value = address
      document.body.appendChild(ele)
      ele.select()
      document.execCommand('copy')
      document.body.removeChild(ele)
      toast.success('Copied to clipboard')
    }
  }

  const [currentTransactionPage, setCurrentTransactionPage] = useState(1)
  const [transactionTotalPages, setTransactionTotalPages] = useState(0)
  const transactionItemsPerPage = 5
  const [transactionPageNumbers, setTransactionPageNumbers] = useState([])
  const calculateTransactionPageNumbers = (totalPages, currentPage) => {
    let pages = []

    if (totalPages <= 4) {
      pages = Array.from({ length: totalPages }, (_, i) => i + 1)
    } else {
      if (currentPage === 1) {
        pages = [1, 2, '...', totalPages - 1, totalPages]
      } else if (currentPage === totalPages) {
        pages = [1, 2, '...', totalPages - 1, totalPages]
      } else {
        if (currentPage + 1 < totalPages) {
          if (currentPage + 1 === totalPages - 1) {
            pages = [currentPage - 1, currentPage, currentPage + 1, totalPages]
          } else {
            pages = [
              currentPage - 1,
              currentPage,
              currentPage + 1,
              '...',
              totalPages
            ]
          }
        } else if (currentPage < totalPages) {
          pages = [currentPage - 1, currentPage, currentPage + 1]
        } else {
          pages = [1, 2, '...', totalPages - 1, totalPages]
        }
      }
    }

    return pages
  }

  const handleTransactionPageChange = newPageNumber => {
    setCurrentTransactionPage(newPageNumber)
    setTransactionPageNumbers(
      calculateTransactionPageNumbers(transactionTotalPages, newPageNumber)
    )
  }

  useEffect(() => {
    const totalPages = Math.ceil(
      history.length / transactionItemsPerPage
    )
    setTransactionTotalPages(totalPages)
    setTransactionPageNumbers(
      calculateTransactionPageNumbers(totalPages, currentTransactionPage)
    )
  }, [history])
  return (
    <div className="flex flex-col min-h-screen" style={{ background: 'var(--page-bg)' }}>
      <div className="flex-grow">
        <TopBar />
        <div className='max-w-7xl mx-auto pt-28 pb-16 px-4 sm:px-6'>
          <div className="flex flex-wrap gap-4 mb-6">
            <CustomRadioButton
              value="Balances"
              selectedValue={selectedOption}
              handleSelect={handleSelect}
            />
            <CustomRadioButton
              value="Trades"
              selectedValue={selectedOption}
              handleSelect={handleSelect}
            />
            <CustomRadioButton
              value="Deploys"
              selectedValue={selectedOption}
              handleSelect={handleSelect}
            />
          </div>
          <div className='flex flex-col md:flex-row gap-6'>
            <section
              className="w-full p-6 rounded-xl"
              style={{
                background: 'var(--card-bg)',
                border: '2px solid transparent',
                backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                boxShadow: 'var(--shadow)'
              }}
            >

              {selectedOption === 'Balances' && (
                <>
                  {funBalances.length > 0 ? (
                    <>
                      {!loading && funBalances.map(({ chainId, name, symbol, contractAddress, logoUrl, balance }, i) => (
                        <div key={i} className="mb-4">
                          <BalanceCard
                            chainId={chainId}
                            chainLogo={chainLogos[chainId]}
                            name={name}
                            symbol={symbol}
                            contractAddress={contractAddress}
                            logoUrl={logoUrl}
                            balance={balance}
                          />
                        </div>
                      ))}
                      {loading && (
                        <div className="flex flex-col gap-4 items-center py-8">
                          <p className="text-lg" style={{ color: 'var(--text-primary)' }}>
                            Loading...
                          </p>
                          <ClipLoader
                            color='var(--text-accent)'
                            loading={true}
                            size={50}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    <div className='text-center py-8' style={{ color: 'var(--text-primary)' }}>
                      No Data
                    </div>
                  )}
                </>
              )}

              {selectedOption === 'Trades' && (
                <>
                  <div className='overflow-x-auto'>
                    <div className="grid grid-cols-4 gap-4 p-3 mb-4" style={{
                      background: 'var(--section-bg)',
                      borderRadius: '8px',
                      minWidth: '600px'
                    }}>
                      <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Token</div>
                      <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Type</div>
                      <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Amount</div>
                      <div className="font-medium" style={{ color: 'var(--text-primary)' }}>Date</div>
                    </div>
                  </div>

                  {history[0].name !== '' ? (
                    history.slice(
                      (currentTransactionPage - 1) * transactionItemsPerPage,
                      currentTransactionPage * transactionItemsPerPage
                    ).map(({ chainId, amount, name, token, type, date }, i) => (
                      <TradeCard
                        key={i}
                        name={name}
                        amount={amount}
                        token={token}
                        type={type}
                        date={date}
                        scanLink={scanLinks[chainId]}
                        coinName={coinNames[chainId]}
                      />
                    ))
                  ) : (
                    <div className='py-4 text-center' style={{ color: 'var(--text-primary)' }}>
                      No Data
                    </div>
                  )}

                  <div className="flex justify-center mt-8">
                    <div className="flex gap-1">
                      <button
                        className="px-3 py-1 rounded-lg"
                        onClick={() => handleTransactionPageChange(1)}
                        style={{
                          background: 'var(--button-secondary-bg)',
                          border: '1px solid var(--button-secondary-border)',
                          color: 'var(--button-secondary-text)'
                        }}
                      >
                        &lt;&lt;
                      </button>
                      <button
                        className="px-3 py-1 rounded-lg"
                        onClick={() => handleTransactionPageChange(Math.max(currentTransactionPage - 1, 1))}
                        style={{
                          background: 'var(--button-secondary-bg)',
                          border: '1px solid var(--button-secondary-border)',
                          color: 'var(--button-secondary-text)'
                        }}
                      >
                        &lt;
                      </button>
                      {transactionPageNumbers.map((pageNumber, index) => (
                        <button
                          key={index}
                          className={`px-3 py-1 rounded-lg ${currentTransactionPage === pageNumber
                            ? 'nav-button active'
                            : 'nav-button'}`}
                          onClick={() => typeof pageNumber === 'number' && handleTransactionPageChange(pageNumber)}
                          style={{
                            border: '1px solid var(--input-border)',
                            color: typeof pageNumber === 'number'
                              ? currentTransactionPage === pageNumber
                                ? 'white'
                                : 'var(--text-primary)'
                              : 'var(--text-secondary)',
                            background: typeof pageNumber === 'number' && currentTransactionPage === pageNumber
                              ? 'var(--button-bg)'
                              : 'var(--card-bg)'
                          }}
                        >
                          {pageNumber}
                        </button>
                      ))}
                      <button
                        className="px-3 py-1 rounded-lg"
                        onClick={() => handleTransactionPageChange(Math.min(currentTransactionPage + 1, transactionTotalPages))}
                        style={{
                          background: 'var(--button-secondary-bg)',
                          border: '1px solid var(--button-secondary-border)',
                          color: 'var(--button-secondary-text)'
                        }}
                      >
                        &gt;
                      </button>
                      <button
                        className="px-3 py-1 rounded-lg"
                        onClick={() => handleTransactionPageChange(transactionTotalPages)}
                        style={{
                          background: 'var(--button-secondary-bg)',
                          border: '1px solid var(--button-secondary-border)',
                          color: 'var(--button-secondary-text)'
                        }}
                      >
                        &gt;&gt;
                      </button>
                    </div>
                  </div>
                </>
              )}

              {selectedOption === 'Deploys' && (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {!loading && funLists.length > 0 && funLists.map((item, i) => (
                      item.tokenName !== '' && (
                        <LaunchpadCard key={i} {...item} />
                      )
                    ))}
                  </div>
                  {!loading && funLists.length === 0 && (
                    <div className='text-center py-8' style={{ color: 'var(--text-primary)' }}>
                      No Data
                    </div>
                  )}
                  {loading && (
                    <div className="flex flex-col gap-4 items-center py-8">
                      <p className="text-lg" style={{ color: 'var(--text-primary)' }}>
                        Loading...
                      </p>
                      <ClipLoader
                        color='var(--text-accent)'
                        loading={true}
                        size={50}
                      />
                    </div>
                  )}
                </>
              )}
            </section>

            {/* Referral Card - Hidden for Deploys */}
            {selectedOption !== 'Deploys' && (
              <div className="w-full md:w-96 h-fit p-6 rounded-xl" style={{
                background: 'var(--card-bg)',
                border: '2px solid transparent',
                backgroundImage: 'linear-gradient(var(--card-bg), var(--card-bg)), var(--card-border)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                boxShadow: 'var(--shadow)'
              }}>
                <div className="text-center mb-6">
                  <h3 className='text-2xl font-bold mb-2' style={{ color: 'var(--text-primary)' }}>
                    Earn <span style={{ color: 'var(--text-accent)' }}>0.5%</span> of each trade
                  </h3>
                  <p className="text-md" style={{ color: 'var(--text-primary)' }}>
                    Share referral link with your friends and earn 0.5% of every trade they make.
                  </p>
                </div>
                <div className='flex gap-2'>
                  <div className='flex-1 p-3 rounded-lg truncate' style={{
                    background: 'var(--input-bg)',
                    border: '1px solid var(--input-border)',
                    color: 'var(--input-color)'
                  }}>
                    {referlink}
                  </div>
                  <button
                    className='p-3 rounded-lg flex items-center justify-center transition-colors'
                    onClick={copyAddress(referlink)}
                    style={{
                      background: 'var(--button-secondary-bg)',
                      border: '2px solid var(--button-secondary-border)',
                      color: 'var(--button-secondary-text)',
                      minWidth: '44px'
                    }}
                  >
                    <ClipboardIcon />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Profile

const ClipboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    width="20"
    height="20"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-2m-2-2h-4m0 0h4m-4 0v2h4V3m-4 6h4"
    />
  </svg>
);